<template>
  <a-select
    :loading="loadingList"
    allowClear
    show-search
    :filter-option="false"
    :defaultActiveFirstOption="false"
    @search="onSearchSelect"
    @change="handleInput"
    v-bind="{
      ...selectProps,
      defaultValue: selectProps.defaultValue
        ? selectProps.defaultValue
        : undefined,
    }"
  >
    <a-select-option v-if="!isEmptyQuery" disabled key="undefined">
      <a-spin v-if="loadingList" size="small" />
      <span v-else> Enter to search </span>
    </a-select-option>
    <a-select-option v-if="isEmptyQuery" disabled key="empty">
      <a-spin v-if="loadingList" size="small" />
      <span v-else>No search results found</span>
    </a-select-option>
    <a-select-option
      v-for="item in checkInitialDatasWithQueryData(datas, initialDatas)"
      :key="item.id"
    >
      {{ item.name }}
    </a-select-option>
  </a-select>
</template>
<script>
import query from "./constant/query";
import debounce from "lodash/debounce";
export default {
  props: {
    selectProps: {
      type: Object,
      default() {
        return {};
      },
    },
    initialDatas: {
      type: Array,
      default() {
        return [];
      },
    },
    variablesQuery: {
      type: Object,
      default() {
        return {};
      },
    },
    setLoading: {
      type: Function,
      default() {
        return {};
      },
    },
  },
  data() {
    this.onSearchSelect = debounce(this.onSearchSelect, 500);
    return {
      loadingList: false,
      loadingDone: false,
      datas: [],
      filter: {},
      isEmptyQuery: false,
    };
  },
  model: {
    event: "change",
  },
  watch: {
    loadingDone() {
      this.setLoading(this.loadingDone);
    },
  },
  methods: {
    handleInput(value) {
      this.$emit("change", value);
    },
    onSearchSelect(input, option) {
      this.datas = [];
      this.$set(this.filter, "query", input);
      this.onGetAllBranchLocation();
    },
    checkInitialDatasWithQueryData(queryDatas, initialDatas) {
      if (initialDatas?.length > 0) {
        const uniqueInitialDatas = [];
        for (let i in initialDatas) {
          const item = initialDatas[i];
          const find = queryDatas.find((e) => e.id === item.id);
          if (!find) {
            uniqueInitialDatas.push(item);
          }
        }
        return [...queryDatas, ...uniqueInitialDatas];
      } else {
        return [...queryDatas];
      }
    },
    onGetAllBranchLocation() {
      this.loadingList = true;
      this.loadingDone = false;
      this.$apollo
        .query({
          query: query.getAllBranchLocation,
          fetchPolicy: "no-cache",
          variables: {
            query: this.filter.query,
            limit: 20,
            page: 1,
            ...this.variablesQuery,
          },
        })
        .then(({ data }) => {
          if (data?.getAllBranchLocation?.length > 0) {
            this.datas = [...data.getAllBranchLocation];
            this.isEmptyQuery = false;
          } else {
            this.datas = [];
            this.isEmptyQuery = true;
          }

          this.loadingList = false;
          this.loadingDone = true;
        })
        .catch((error) => {
          this.loadingList = false;
          console.error("Error get list", error);
        });
    },
  },
  created() {
    if (this.initialDatas?.length > 0) {
      this.datas = [...this.initialDatas];
    } else {
      this.onGetAllBranchLocation();
    }
  },
};
</script>
